
<template>
  <div style="padding: 20px 0px 0px 20px; ">

    <el-form style="display: flex;flex-wrap: wrap;">

        <el-form-item label="学生姓名:" style="display: flex;width: 33%;">
            <el-input  placeholder="请输入学生姓名" v-model="text1"></el-input>
        </el-form-item>

         <el-form-item label="微信姓名:" style="display: flex;width: 33%;">
            <el-input  placeholder="请输入微信姓名" v-model="text11"></el-input>
        </el-form-item>

        <el-form-item label="所属城区:" style="display: flex;width: 33%;">
          <el-input  placeholder="请输入所属城区" v-model="text2"></el-input>
            <!-- <el-select placeholder="请选择城区" v-model="text2" style="width: 100%" clearable filterable>
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"  :value="item.dictValue"></el-option>
            </el-select> -->
        </el-form-item>

        <el-form-item label="目前年级:" style="display: flex;width: 33%;">
            <el-cascader clearable style="width: 100%;" v-model="text3" :options="gradeList"  :props="props"></el-cascader>
        </el-form-item>

        <el-form-item label="创建时间:" style="display: flex;width: 33%;">
              <el-date-picker style="width: 100%"  v-model="text4" type="daterange" value-format="yyyy-MM-dd" range-separator="至"   start-placeholder="开始日期"   end-placeholder="结束日期" clearable></el-date-picker>
        </el-form-item>

        <el-form-item label="提交时间:" style="display: flex;width: 33%;">
              <el-date-picker style="width: 100%"  v-model="text5" type="daterange" value-format="yyyy-MM-dd" range-separator="至"   start-placeholder="开始日期"   end-placeholder="结束日期" clearable></el-date-picker>
        </el-form-item>

        
    </el-form>

    <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px; margin-top: -10px;">
       <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
       <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
    </div>


    <!-- <div class="table">
      <span style="width: 10%;">姓名</span>
      <span style="width: 10%;">头像</span>
      <span style="width: 10%;">微信号</span>
      <span style="width: 10%;">所属地域</span>
      <span style="width: 10%;">电话号码</span>
      <span style="width: 20%;">所属运营人员</span>
      <span style="width: 20%;">电话沟通状态</span>
      <span style="width: 20%;">创建时间</span>
      <span style="width: 20%;">问卷提交时间</span>
      <span style="width: 20%;">操作</span>
    </div>

    <div class="table" v-for="(item, index) in tableData" :key="index" style="width: ;">
      <span>{{item.weChatName}}</span>
      <span>
        <viewer :images="item.profilePhotos">
          <img v-for="(src, index) in item.profilePhotos" :src="src" :key="index" style="height: 50px; width: 50px; border-radius: 50%;" />
        </viewer>
      </span>
      <span>{{item.weChatNumber}}</span>
      <span>{{item.regionName}}</span>
      <span>{{item.phoneNumber}}</span>
      <span>{{item.marketName}}</span>
      <span>
        <span style="color:#4992df;padding: 0px 5px;" v-if="item.telephoneStatus === 0">未沟通</span>
        <span style="color:#4992df;padding: 0px 5px;" v-if="item.telephoneStatus === 1">已沟通</span>
        <span style="color:#4992df;padding: 0px 5px;" v-if="item.telephoneStatus === 2">待沟通</span>
      </span>
      <span>{{item.createTime}}</span>
      <span>{{item.newCommitDate}}</span>
      <span>
        <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(item,'编辑')">编辑</span>
        <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(item,'详情')">查看</span>
      </span>
    </div> -->



    <el-table  :data="tableData" height="700" @sort-change="handleChengSort" 
    stripe style="width: 100%;" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
        <el-table-column  prop="weChatName" show-overflow-tooltip label="微信姓名" ></el-table-column>
        <el-table-column  prop="profilePhotos" show-overflow-tooltip label="头像" >
          <template slot-scope="scope">
              <viewer :images="scope.row.profilePhotos">
                <img  v-for="(src, index) in scope.row.profilePhotos" :src="src"  :key="index" style="height: 50px;  width: 50px;  border-radius: 50%;" />
              </viewer>
          </template>
        </el-table-column>
        <el-table-column  prop="studentName" show-overflow-tooltip label="学生姓名"></el-table-column>
        <el-table-column  prop="regionName" show-overflow-tooltip label="所属城区"></el-table-column>
        <el-table-column  prop="grade" show-overflow-tooltip label="目前年级" ></el-table-column>
        <el-table-column  prop="marketName" show-overflow-tooltip label="所属运营人员" width="110"></el-table-column>
        <el-table-column  prop="telephoneStatus" show-overflow-tooltip label="电话沟通状态" width="150">
          <template slot-scope="scope">
              <span style="color:#4992df;padding: 0px 5px;" v-if="scope.row.telephoneStatus === 0">未沟通</span>
              <span style="color:#4992df;padding: 0px 5px;" v-if="scope.row.telephoneStatus === 1">已沟通</span>
              <span style="color:#4992df;padding: 0px 5px;" v-if="scope.row.telephoneStatus === 2">待沟通</span>
          </template>
        </el-table-column>
        <el-table-column  prop="createTime" sortable="custom" show-overflow-tooltip label="创建时间" width="150"></el-table-column>
        <el-table-column  prop="newCommitDate" sortable="custom" show-overflow-tooltip label="问卷提交时间" width="150"></el-table-column>
        <el-table-column  label="操作" width="250">
            <template slot-scope="scope">
              <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'编辑')">编辑</span>
              <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'详情')">查看</span>
            </template>
        </el-table-column>
    </el-table>


    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next,sizes,jumper">
    </el-pagination>


    <el-drawer title="客户信息" :before-close="handleCloseDrawerCler" :visible.sync="dialogDrawer" direction="rtl" custom-class="demo-drawer" ref="drawer" close-on-press-escape size="25%">


      <!-- <div style="display: flex; margin-bottom: 20px; width: 98%;" class="no_click">
        <span style="width: 100px; padding-top: 5px;">客户:</span>
        <el-input v-model="from.input1" ></el-input>
      </div> -->

      <div style="display: flex;margin-bottom: 20px; width: 98%;">
          <img v-for="(src, index) in imagesList" :src="src"  :key="index" style="height: 40px;  width: 40px;  border-radius: 50%; top: 6px;left: 100px; position: absolute;" />
      </div>


      <div style="display: flex;margin-bottom: 20px; width: 98%;" class="no_click">
        <span style="width: 100px; padding-top: 5px;">姓名:</span>
        <el-input v-model="from.input2" ></el-input>
      </div>

      <div style="display: flex;margin-bottom: 20px; width: 98%;">
        <span style="width: 100px; padding-top: 5px;">微信号:</span>
        <el-input :disabled="disable" v-model="from.input3" placeholder="请输入微信"></el-input>
      </div>

      <div style="display: flex;margin-bottom: 20px; width: 98%;">
        <span style="width: 100px; padding-top: 5px;">电话号码:</span>
        <el-input :disabled="disable" v-model="from.input4" placeholder="请输入电话号码"></el-input>
      </div>

      <div style="display: flex;margin-bottom: 20px; width: 98%; margin-top: 20px;" >
          <div style="display:flex;text-align: center;  border-radius: 4px;width: 100%; margin-left: 10px; height:100px; ">
              <div style="width: 33%;border-right: 1px solid #e2dada;border-top: 1px solid #e2dada;border-left: 1px solid #e2dada;border-bottom: 1px solid #e2dada;padding-top: 30px;" @click="handleClickType('查看问卷')">
                <i class="el-icon-document"></i>
                <div style="padding-top: 5px;">查看问卷</div>
              </div>
              <div style="width: 33%;border-right: 1px solid #e2dada;padding-top: 30px;border-top: 1px solid #e2dada;border-bottom: 1px solid #e2dada;" @click="handleClickType('电话沟通')">
                <i class="el-icon-phone-outline"></i>
                <div style="padding-top: 5px;">电话沟通</div>
              </div>
              <!-- <div style="width: 33%;"></div> -->
          </div>
      </div>


      <el-drawer :title="nodeTitle" :append-to-body="true"  :before-close="handleCloseNode"  :visible.sync="innerNodeDrawer" size="30%">

          <div style=" border-radius: 10px; padding: 7px; border: 1px solid #ebdfdf;  width: 97%; margin-left: 7px;"  v-if="!showTo">
            <div v-for="(itme,index) in QuestionnaireViewLsit" :key="index" @click="handleClickitmes(itme)">
              <h4 :style="{ paddingLeft: itme.questionnaireType === 3 ? '15px' : '0px' }">{{ itme.titleName }}</h4>
              <div style="padding-left: 13px;"> {{ itme.createTime }} </div>
            </div>
          </div>


          <div style=" margin-bottom: 20px;display: flex;justify-content: space-between;" v-if=" dataList.length > 0 && showBtns">
              <div @click="handleClickTo" style="margin-top: 5px;">
                <i class="el-icon-back"></i>
                <span style="  padding: 5px 10px;  border-radius: 10px;  color: #fff;  background: #40a9ff;">返回</span>
              </div>
              <div @click="exportToPDF" style="  padding: 5px 10px;  border-radius: 10px;  color: #fff;  background: #40a9ff;">下载</div>
          </div>

          <div style="width: 97%; margin-left: 7px;"  v-if="dataList && dataList.length > 0"  id="dataList2d">

            <div  v-for="(item,index) in dataList" :key="index" class="no_click" >

                <div  v-if="item.tepy === 1 || item.tepy === 6" style="margin-top: 40rpx; padding-left: 5%;">
                  <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
                  <!-- <el-input type="text"  
                  style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
                  :placeholder="item.placeholderText"  v-model="item.input"></el-input> -->
                  <div style="margin: 15px 0; background-color: #f7f8f9; width: 100%; min-height: 30px; border-radius: 10rpx; margin-top: 10rpx; padding-left: 20rpx; word-break: break-all;font-size: 15px;color: #373535;">
                    {{ item.input }}
                  </div>
                </div>


                <div class="" v-if="item.tepy === 2" style="margin-top: 40rpx; padding-left: 5%;">
                  <div style=" margin-bottom: 19px;">
                    <span style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.</span>
                    <span style="border: 1px solid #eca654;color: #f1a951;border-radius: 10rpx;margin: 0rpx 10rpx;padding: 3px 10px;font-size: 10px;">单选题</span>
                    <span style="font-size:  14px; color: #9a9696;">{{ item.text }}</span>
                  </div>
                  <el-button class="checkbuts" style="height: 28px;font-size: 25rpx;margin-left: 20px; margin-bottom: 20px;" size="small"
                  :style="{
                    backgroundColor: items.activation === 1 || items.switchinput ? '#fef3de' : '',
                    color: items.activation === 1 || items.switchinput ? '#d48a60' : ''
                  }"
                  v-for="(items,indexs) in item.typeList"
                  :key="indexs">{{ items.type }} {{ items.name }} {{ items.switchinput }}</el-button>
                </div>


                <div  v-if="item.tepy === 3" style="margin-top: 40rpx; padding-left: 5%;">
                  <div style=" margin-bottom: 19px;">
                    <span style="font-size:  14px;color: #9a9696;" >{{ index + 1 }}.</span>
                    <span style="border: 1px solid #eca654;color: #f1a951;border-radius: 10rpx;margin: 0rpx 10rpx;padding: 3px 10px;font-size:  10px;">多选题</span>
                    <span style="font-size:  14px;color: #9a9696;">{{ item.text }}</span>
                  </div>
                  <el-button class="checkbuts" style="height: 28px;font-size: 25rpx; margin-left: 20px; margin-bottom: 20px;" size="small"
                  :style="{
                    backgroundColor: items.activation === 1 || items.switchinput ? '#fef3de' : '',
                    color: items.activation === 1 || items.switchinput ? '#d48a60' : ''
                  }"
                  v-for="(items,indexs) in item.typeList"
                  :key="indexs"
                  >{{ items.type }} {{ items.name }} {{ items.switchinput }}</el-button>
                </div>


                <div  v-if="item.tepy === 4" style="margin-top: 40rpx; padding-left: 5%;">
                  <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
                  <el-input style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
                    placeholder="请选择通话日期" v-model="item.valueDate">
                  </el-input>
                </div>


                <div v-if="item.tepy === 5" style="margin-top: 40rpx; padding-left: 5%;">
                  <span  style="font-size:  14px; color: #9a9696;" >{{ index + 1 }}.{{ item.text }}</span>
                  <el-input style="margin: 15px 0px;background-color: #f7f8f9;width: 92%; height: 100rpx;margin-left: 3%;border-radius: 10rpx;margin-top: 10rpx;padding-left: 20rpx;"
                    placeholder="请选择通话时间" v-model="item.valueTime">
                  </el-input>
                </div>


              </div>


          </div>


      </el-drawer>



      <el-drawer title="电话沟通" :append-to-body="true"  :before-close="handleCloseTelephone"  :visible.sync="telephoneDrawer" size="30%">

        <el-button :class="disable ? 'no_click' : ''" type="primary" icon="el-icon-plus" style="width:98%; margin-left: 5px;" @click="handleClickAdd">添加电话沟通</el-button>

        <div style="font-size: 14px;border: 1px solid rgb(204 197 197); border-radius: 8px; width: 97%;  margin-top: 40px;  margin-left: 9px;padding: 8px; overflow-y: auto; height: 75vh;">

            <div  class="boxshadow"  style="margin-bottom: 20px;" v-for="(item,index) in telephoneList" :key="index + 'ABC'">

              <div style="color: #fff;padding: 10px 0px;  background: #95d1e8;  padding-left: 10px; border-radius: 5px; margin-bottom: 10px; display: flex;justify-content: space-between;">
                <span>第{{ index + 1 }}次电话</span>
                <i class="el-icon-circle-close" style="margin-top: 4px; margin-right: 10px;" :class="disable ? 'no_click' : ''"  @click="handleClickRend(index)"></i>
              </div>

              <div style="margin-bottom: 20px;display: flex;" :class="disable ? 'no_click' : ''">
                <div style="width: 150px; margin-top: 4px;">预约时间:</div>
                <el-date-picker  v-model="item.appointmentTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 100%;" placeholder="选择日期"></el-date-picker>
              </div>

              <div style="margin-bottom: 20px;display: flex;" :class="disable ? 'no_click' : ''">
                <div  style="width: 150px; margin-top: 4px;">实际沟通时间:</div>
                <el-date-picker  v-model="item.communicationTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 100%;" placeholder="选择日期"></el-date-picker>
              </div>

              <div style="margin-bottom: 20px;display: flex;" >
                <div  style="width: 150px; margin-top: 4px;">沟通录音:</div>
                <el-button style="width: 45%;" :class="disable ? 'no_click' : ''" icon="el-icon-plus" type="primary" size="small" @click="handleUpload('录音',item,index)">点击上传</el-button>
                <el-button style="width: 45%;" icon="el-icon-view" type="primary" size="small" @click="handleUpload('查看录音',item,index)">查看录音</el-button>
              </div>

              <div style="margin-bottom: 20px;display: flex;">
                <div  style="width: 150px; margin-top: 4px;">沟通截图:</div>
                <el-button style="width: 45%;" :class="disable ? 'no_click' : ''" icon="el-icon-plus" type="primary" size="small" @click="handleUpload('截图',item,index)">点击上传</el-button>
                <el-button style="width: 45%;" icon="el-icon-view" type="primary" size="small" @click="handleUpload('查看截图',item,index)">查看截图</el-button>
              </div>

              <div style="margin-bottom: 20px;display: flex;" :class="disable ? 'no_click' : ''">
                <div  style="width: 150px; margin-top: 4px;">沟通人:</div>
                <el-select v-model="item.communicationPerson" multiple filterable clearable placeholder="请选择沟通人" style="width: 100%;">
                  <el-option  v-for="(e,i) in options"  :key="i + 'INIT'"  :label="e.realname" :value="e.id"> </el-option>
                </el-select>
              </div>

              <div style="margin-bottom: 20px;display: flex;" :class="disable ? 'no_click' : ''">
                <div  style="width: 150px; margin-top: 4px;">沟通目的:</div>
                <el-input v-model="item.communicationGoal" type="textarea"   maxlength="500" show-word-limit placeholder="请输入沟通目的" :autosize="{ minRows: 6, maxRows: 6}"></el-input>
              </div>

              <div style="margin-bottom: 20px;display: flex;" :class="disable ? 'no_click' : ''">
                <div  style="width: 150px; margin-top: 4px;">备注:</div>
                <el-input v-model="item.remark" type="textarea"   maxlength="500" show-word-limit placeholder="请输入备注" :autosize="{ minRows: 6, maxRows: 6}"></el-input>
              </div>

              <div style="text-align: end; margin-bottom: 15px; padding-top: 25px;">
                  <el-button size="small" v-if="!disable" type="primary" @click="handleCloseTelephoneSubt(item,index)">保存</el-button>
              </div>

            </div>

        </div>

        <span style="position: fixed; bottom: 10px; right: 10px;">
            <div style="text-align: end;">
                <el-button size="small"  @click="handleCloseTelephone">关闭</el-button>
            </div>
        </span>

      </el-drawer>



      <span style="position: fixed;   bottom: 10px;  right: 10px;">
          <div style="text-align: end;">
              <el-button v-if="!disable" size="small" type="primary" @click="closeEditDialogSubt">确认</el-button>
              <el-button size="small"  @click="rejectDialogShowClr">关闭</el-button>
          </div>
      </span>

    </el-drawer>

    <Elupload v-if="isShowElupload" @handleEventElUpload="handleEventElUpload" @handleEventElUploadSubt="handleEventElUploadSubt" :Uploadtypes="Uploadtypes" :fileAllLists="fileAllLists"></Elupload>


  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";
import Elupload from "./Elupload";
import { getTeachers,} from "@/api/feedBackApi";
import { Loading } from 'element-ui';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



export default {
  components: { Elupload },
  data(){
    return{

        props: {
          label: "gradeName",
          children: "children",
          value: "gradeName"
        },

        studentName:'',

        Time1:'',
        Time2:'',
        inputtextarea:'',


        optionList1:[],
        optionList2:[],
        optionList3:[{id:0,name:'待审批'},{id:1,name:'驳回'},{id:2,name:'已完成'}],

        dialogDrawer: false,

        nodeTitle:'',
        innerNodeDrawer: false,

        telephoneDrawer: false,

        input1:'',
        input2:'',
        input3:'',


        from:{
          // input1:'',
          input2:'',
          input3:'',
          input4:'',
        },

        tableData: [],

        optionList4:[ {id:'1', realname:'未沟通',},{ id:'2', realname:'进行中',}, { id:'3', realname:'已沟通',}],

        pageNum:1,
        pageSize:10,
        total: 10,


        disable:false,

        showTo:false,


        dataList:[],


        telephoneList:[],

        isShowElupload:false,
        Uploadtypes:'',

        fileAllLists:[],
        indexItme:'',


        options:[],

        fromsID:null,

        QuestionnaireViewLsit:[],
        imagesList:[],

        titleis:'',

        showBtns:true,

        orderBy: 'desc',
        sortNameBy: 'new_commit_date',
        optionsListt: [],

        gradeList: [],
        grade:'',

        input9:[],





        text1:'',
        text2:'',
        text3:'',
        text4:[],
        text5:[],
        text11:'',
        
        createTime:'',

    }
  },
  mounted(){

        axios.get(`${apiBaseUrl}/grade/getGrade`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }) .then(res => {
          if (res.data.data.length > 0) {
             this.gradeList = res.data.data;
          } else {
            this.$message({  message: "获取年级列表失败",  type: "error"  });
          }
        }).catch(error => {
          this.gradeList = [];
          console.log(error);
        });

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
      this.optionsListt = res.data.data
    })

    this.getApiList()
    // setInterval(()=>{ this.getApiList() },3000)
    getTeachers().then((res) => { this.options = res.data });
    axios.get(`${apiBaseUrl}/teacher/teacherSale`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
        this.optionList2  = res.data.data
    })
  },
  methods:{

    handleChengSort({ column, prop, order }){

      console.log( prop, order)

      let orderBy = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      let sortNameBy = (prop === 'createTime' && order) ? 'create_time' : (prop === 'newCommitDate' && order) ? 'new_commit_date' : '';

      this.orderBy = orderBy;
      this.sortNameBy = sortNameBy; 

      if(prop === 'createTime'){
        axios.post(`${apiBaseUrl}/wx_questionnaire/findPage`, { pageNum: this.pageNum, pageSize: this.pageSize, sortName: this.sortNameBy, order: this.orderBy },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
          if(res.data.code === 200){
              if(res.data.data.records && res.data.data.records.length > 0){
                res.data.data.records.forEach((itme)=>{
                  itme.profilePhotos = []
                  itme.profilePhotos.push(itme.profilePhoto)
                })
                this.tableData = res.data.data.records
                this.pageNum = res.data.data.current
                this.pageSize = res.data.data.size
                this.total = res.data.data.total
              }else{
                this.tableData = []
                this.pageNum = 1
                this.pageSize = 10
                this.total = 0
              }
              this.$message({ type: 'success', message: '查询成功~'})
          }else{
              this.$message({ type: 'error', message: '查询失败~' })
          }
        })
      }
      

      if(prop === 'newCommitDate'){
        axios.post(`${apiBaseUrl}/wx_questionnaire/findPage`, { pageNum: this.pageNum, pageSize: this.pageSize, sortName: this.sortNameBy, order: this.orderBy },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
          if(res.data.code === 200){
              if(res.data.data.records && res.data.data.records.length > 0){
                res.data.data.records.forEach((itme)=>{
                  itme.profilePhotos = []
                  itme.profilePhotos.push(itme.profilePhoto)
                })
                this.tableData = res.data.data.records
                this.pageNum = res.data.data.current
                this.pageSize = res.data.data.size
                this.total = res.data.data.total
              }else{
                this.tableData = []
                this.pageNum = 1
                this.pageSize = 10
                this.total = 0
              }
              this.$message({ type: 'success', message: '查询成功~'})
          }else{
              this.$message({ type: 'error', message: '查询失败~' })
          }
        })
      }


    },

    exportToPDF() {

      const pdfName =  this.studentName
      const pdfNames = this.createTime

      this.showBtns = false;

      const loadingObj = Loading.service({
        lock: true,
        text: '生成PDF中，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)',
      });

      const canvas2d = document.getElementById('dataList2d'); // 要导出的 DOM 元素

      html2canvas(canvas2d, {
        useCORS: true, // 允许跨域
        scale: 3, // 提高分辨率
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png'); // 将 canvas 转为图片

        // 获取内容的实际宽高
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;

        // 自定义 PDF 尺寸（根据内容高度动态调整）
        const pdfWidth = 210; // A4 宽度，单位 mm
        const pdfHeight = (contentHeight * pdfWidth) / contentWidth; // 按比例计算高度，单位 mm

        const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight]); // 创建自定义尺寸的 PDF 实例

        // 将内容添加到 PDF 中
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        // 将 PDF 转为 Blob 对象
        const pdfBlob = pdf.output('blob');
        // 创建一个新的 URL 并在新页面中打开
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // window.open(pdfUrl, '_blank'); // 在新页面中打开 PDF
       // 下载 PDF 文件
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `${pdfName} - ${pdfNames} - ${this.titleis}.pdf`; // 设置下载文件名
        link.click();

        loadingObj.close();
        this.showBtns = true;
        

        loadingObj.close();
        this.showBtns = true;
      }).catch((err) => {
        console.error('PDF生成失败:', err);
        this.$message.error('PDF生成失败');
        loadingObj.close();
        this.showBtns = true;
      });


    },



    captureCanvas2D(){

        this.showBtns = false

        const loadingObj =  Loading.service({ lock: true,  text: '下载中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'})

        const canvas2d = document.getElementById('dataList2d')
        const scrollHeight = this.titleis === '（咨询单）家庭教育一站式落地陪跑' ? 5500 : 3000
        const scrollWidth = 500

        const fullCanvas = document.createElement('canvas')
        fullCanvas.width = scrollWidth
        fullCanvas.height = scrollHeight
        const fullCtx = fullCanvas.getContext('2d')


        for (let y = 0; y < scrollHeight; y += fullCanvas.height) {
            for (let x = 0; x < scrollWidth; x += fullCanvas.width) {
              html2canvas(canvas2d, {
                scrollX: x,
                scrollY: y,
                width: fullCanvas.width,
                height: fullCanvas.height,
                useCORS: true
              }).then((canvas) => {
                fullCtx.drawImage(canvas, x, y)
              })
            }
        }

        setTimeout(() => {
          let imgData = fullCanvas.toDataURL('image/jpg')
          let link = document.createElement('a')
          link.href = imgData
          link.download = this.titleis + '.jpg'
          link.click()
          fullCanvas.remove()
          loadingObj.close()
          this.showBtns = true
        }, 3000)


    },

    handleEventElUploadSubt(flileList){
      this.isShowElupload = false
        if(flileList && flileList.length > 0){
            this.fileAllLists = flileList
            if(this.Uploadtypes === '查看录音' || this.Uploadtypes === '录音'){
                this.telephoneList[this.indexItme].communicationRecord = this.fileAllLists
            }

            if(this.Uploadtypes === '查看截图' || this.Uploadtypes === '截图'){
                this.telephoneList[this.indexItme].screenshot = this.fileAllLists
            }

        }

        this.fileAllLists = []
    },

    handleEventElUpload(flileList){
        this.isShowElupload = false
    },

    handleUpload(type,itme,index){
      this.Uploadtypes = type
      this.indexItme = index
      this.fileAllLists = []


      if(type === '录音' || type === '查看录音'){
        if(itme.communicationRecord){
            this.fileAllLists = itme.communicationRecord
        }else{
            this.fileAllLists = []
        }
      }

      if(type === '截图' || type === '查看截图'){
        if(itme.screenshot){
            this.fileAllLists = itme.screenshot
        }else{
            this.fileAllLists = []
        }

      }

      this.isShowElupload = true
    },

    handleClickTo(){
      this.showTo = false
      this.dataList = []
    },

    handleClickitmes(e){
      this.titleis = e.titleName
      this.studentName = e.studentName ? e.studentName : ''
      this.createTime = e.createTimeStr ? e.createTimeStr : ''
      this.showTo = true
      if(Array.isArray(e.questionnaireContent)){
          this.dataList = e.questionnaireContent
      }
    },

    handleClickType(e){

      if(e === '查看问卷'){
        this.nodeTitle = '填写的问卷'
        this.handleQuestionnaireView()
        this.innerNodeDrawer = true
        this.showTo = false
      }

      if(e === '电话沟通'){
        this.handleFindCommunication()
        this.telephoneDrawer = true
      }

    },

    handleQuestionnaireView(){
      axios.get(`${apiBaseUrl}/wx_questionnaire/findContent/${this.fromsID.openId}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
          if(res.data.code === 200){
              if( res.data.data && res.data.data.length > 0){
                let data = res.data.data
                data.forEach((itme)=>{
                  if(itme.questionnaireContent){
                    itme.questionnaireContent = JSON.parse(itme.questionnaireContent)
                  }
                })
                this.QuestionnaireViewLsit = data
              }else{
                this.QuestionnaireViewLsit = []
              }
          }else{
              this.$message({ type: 'error', message: 'error: wx_questionnaire/findContent~openID' })
          }
      })
    },


    handleFindCommunication(){
      axios.get(`${apiBaseUrl}/wx_questionnaire/findCommunication/${this.fromsID.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
          if(res.data.code === 200){
              if( res.data.data && res.data.data.length > 0){
                let data = res.data.data
                data.forEach((itme)=>{
                  if(itme.communicationRecord){
                      itme.communicationRecord = JSON.parse(itme.communicationRecord)
                  }else{
                    itme.communicationRecord = ''
                  }

                  if(itme.screenshot){
                      itme.screenshot = JSON.parse(itme.screenshot)
                  }else{
                    itme.screenshot = ''
                  }

                  if(itme.communicationPerson){
                      itme.communicationPerson = itme.communicationPerson.split(',')
                      itme.communicationPerson = itme.communicationPerson.map((e)=>{
                        return Number(e)
                      })
                  }
                })
                this.telephoneList = data
                this.getApiList()
              }else{
                this.telephoneList = []
              }
          }else{
              this.$message({ type: 'error', message: 'error: wx_questionnaire/findCommunication~' })
          }
      })
    },

    handleCloseTelephone(){
      this.telephoneDrawer = false
    },

    handleCloseTelephoneSubt(itme,index){



      if(itme.id){

          itme.questionnaireId = this.fromsID.id

          if(itme.communicationRecord && Array.isArray(itme.communicationRecord)){
            itme.communicationRecord = JSON.stringify(itme.communicationRecord)
          }else{
            itme.communicationRecord = ''
          }

          if(itme.screenshot && Array.isArray(itme.screenshot)){
            itme.screenshot = JSON.stringify(itme.screenshot)
          }else{
            itme.screenshot = ''
          }

          if(itme.communicationPerson && itme.communicationPerson.length > 0){
            itme.communicationPerson = itme.communicationPerson.join(',')
          }else{
            itme.communicationPerson = ''
          }

          axios.post(`${apiBaseUrl}/wx_questionnaire/updateCommunication`, itme ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if(res.data.code === 200){
                this.$message({ type: 'success', message: '修改成功~' })
                this.getApiList()
                this.handleFindCommunication()
            }else{
                this.$message({ type: 'error', message: '修改失败~' })
            }
          })
      }else{

          itme.questionnaireId = this.fromsID.id

          if(itme.communicationRecord && Array.isArray(itme.communicationRecord)){
            itme.communicationRecord = JSON.stringify(itme.communicationRecord)
          }else{
            itme.communicationRecord = ''
          }

          if(itme.screenshot && Array.isArray(itme.screenshot)){
            itme.screenshot = JSON.stringify(itme.screenshot)
          }else{
            itme.screenshot = ''
          }

          if(itme.communicationPerson && itme.communicationPerson.length > 0){
            itme.communicationPerson = itme.communicationPerson.join(',')
          }else{
            itme.communicationPerson = ''
          }

          axios.post(`${apiBaseUrl}/wx_questionnaire/addCommunication`, itme ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if(res.data.code === 200){
                this.$message({ type: 'success', message: '添加成功~' })
                this.getApiList()
                this.handleFindCommunication()
            }else{
                this.$message({ type: 'error', message:  '添加失败~' })
            }
          })

      }




      // if(this.telephoneList && this.telephoneList.length > 0){
      //     this.telephoneList.map((itme)=>{

      //         itme.questionnaireId = this.fromsID.id

      //         if(itme.communicationRecord && Array.isArray(itme.communicationRecord)){
      //           itme.communicationRecord = JSON.stringify(itme.communicationRecord)
      //         }

      //         if(itme.screenshot && Array.isArray(itme.screenshot)){
      //           itme.screenshot = JSON.stringify(itme.screenshot)
      //         }

      //         if(itme.communicationPerson && itme.communicationPerson.length > 0){
      //           itme.communicationPerson = itme.communicationPerson.join(',')
      //         }

      //         axios.post(`${apiBaseUrl}/wx_questionnaire/${itme.id ? 'updateCommunication' : 'addCommunication'}`, itme ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
      //           if(res.data.code === 200){
      //               this.$message({ type: 'success', message: itme.id ? '修改成功~' : '添加成功~' })
      //               this.telephoneList = []
      //               this.getApiList()
      //           }else{
      //               this.$message({ type: 'error', message: itme.id ? '修改失败~' : '添加失败~' })
      //           }
      //         })
      //     })
      //     this.telephoneDrawer = false
      // }else{
      //   this.$message({ type: 'warning', message: '请填写电话沟通信息~' })
      // }
    },

    handleCloseNode(){
      this.nodeTitle = ''
      this.dataList = []
      this.innerNodeDrawer = false
      this.showTo = false

    },


    closeEditDialogSubt(){

      axios.post(`${apiBaseUrl}/wx_questionnaire/update`, { weChatNumber: this.from.input3, phoneNumber: this.from.input4, id: this.fromsID.id },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
        if(res.data.code === 200){
            this.$message({ type: 'success', message: '修改成功~' })
            this.getApiList()
            this.dialogDrawer = false
        }else{
            this.$message({ type: 'error', message: '修改失败~' })
        }
      })

    },

    rejectDialogShowClr(){
      this.dialogDrawer = false
    },

    searchBtns(){
      this.getApiList()
    },

    getApiList(){
      let ret = this.text3 && this.text3.length > 0 ? this.text3[1] : ''
      axios.post(`${apiBaseUrl}/wx_questionnaire/findPage`, { 
        studentName: this.text1,
        weChatName: this.text11,
        grade: ret,
        regionName :  this.text2,
        createTimeStart :  this.text4 && this.text4.length > 0 ? this.text4[0] + ' 00:00:00': '',
        createTimeEnd :  this.text4 && this.text4.length > 0 ? this.text4[1] + ' 23:59:59': '',
        newCommitDateStart :  this.text5 && this.text5.length > 0  ? this.text5[0] + ' 00:00:00': '',
        newCommitDateEnd :  this.text5 && this.text5.length > 0  ? this.text5[1] + ' 23:59:59': '',

        pageNum: this.pageNum, 
        pageSize: this.pageSize, 
        sortName: this.sortNameBy ? this.sortNameBy : 'new_commit_date', 
        order: this.orderBy ? this.orderBy : 'desc'
      },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
        if(res.data.code === 200){
            if(res.data.data.records && res.data.data.records.length > 0){
              res.data.data.records.forEach((itme)=>{
                itme.profilePhotos = []
                itme.profilePhotos.push(itme.profilePhoto)
              })
              this.tableData = res.data.data.records
              this.pageNum = res.data.data.current
              this.pageSize = res.data.data.size
              this.total = res.data.data.total
            }else{
              this.tableData = []
              this.pageNum = 1
              this.pageSize = 10
              this.total = 0
            }
            this.$message({ type: 'success', message: '查询成功~'})
        }else{
            this.$message({ type: 'error', message: '查询失败~' })
        }
      })
    },

    handleClickAdd(){
      this.telephoneList.push(
        {
          appointmentTime:'',
          communicationTime:'',
          communicationRecord:[],
          screenshot:[],
          communicationGoal:'',
          remark:'',
          communicationPerson:[],
        }
      )
    },


    handleClickRend(index){
      this.telephoneList.splice(index, 1)
    },



    handlegoDialog(){
        goDialog({
          message: '导入数据将覆盖内容，此操作不可撤回，是否继续？',
          isMaskClosable: true,
          transformOrigin: 'center',
          onPositiveCallback: async () => {
            try {
              const files = await showOpenFilePicker()
              const file = await files[0].getFile()
              const fr = new FileReader()
              fr.readAsText(file)
              fr.onloadend = () => {
                content.value = (fr.result || '').toString()
              }
              window['$message'].success('导入成功！')
            } catch (error) {
              window['$message'].error('导入失败，请检查文件是否损坏！')
              console.log(error)
            }
          }
        })
      

      // 同步数据编辑页
      window.opener.addEventListener(SavePageEnum.CHART, (e) => {
        window['$message'].success('正在进行更新...')
        setSessionStorage(StorageEnum.GO_CHART_STORAGE_LIST, [e.detail])
        content.value = JSONStringify(e.detail)
      })

      // 保存按钮同步数据
      document.addEventListener('keydown', function (e) {
        if (e.keyCode == 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
          e.preventDefault()
          updateSync()
        }
      })

    },



    clearBtns(){
        this.input1 = ''
        this.input2 = ''
        this.input3 = ''

        this.text1 = ''
        this.text11 = ''
        this.text2 = ''
        this.text3 = ''
        this.text4 = []
        this.text5 = []

        this.sortNameBy = 'new_commit_date'
        this.orderBy = 'desc'


        this.pageNum = 1
        this.pageSize = 10

        this.getApiList()
    },
    handleTreeClick(type, node, data){

        console.log(type, node, data)

        if(type === '添加部门'){
            this.parentNode = node
            this.dialogVisibleAddDepTitle = '添加部门'
            this.dialogVisibleAddDep = true
        }

        if(type === '编辑部门'){
            this.dialogVisibleAddDepTitle = '编辑部门'
            this.depName = data.deptName
            this.depNameID = data.id
            this.dialogVisibleAddDep = true
        }

        if(type === '删除部门'){
            this.$confirm('此操作将删除【教师部】， 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.handleDelete(data.id)
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' })
            })
        }

    },

    allowDrop(draggingNode, dropNode, type) {
        return dropNode.data.deptName !== '蒙正课堂';
    },

    allowDrag(draggingNode) {
        return draggingNode.data.deptName !== '蒙正课堂';
    },

    handleDrop(draggingNode, dropNode, dropType, ev) {
        let { parent, data } = draggingNode
        console.log(draggingNode, dropNode,'handleDrop');
        this.SonNodeID = data.deptId
        this.handleMove()
    },

    handleClickTree(data){
        this.isDisplay = data.isDisplay == 1 ? true : false
        this.isID = data.deptId
        this.isIDS = data.id
        this.handlegetOrgStaffs()
        this.ShowResignationView = false
    },

    handleDragEnter(draggingNode, dropNode, ev) {
        let { data } = dropNode
        console.log(draggingNode, dropNode,'handleDragEnter');
        this.ParentLevelD = data.deptId
    },
    handleInput(e){
      axios.get(`${apiBaseUrl}/organizational/getOrgTree?deptName=${e}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
          if(res.data.data){
              this.dataTree = res.data.data
          }else{
              this.dataTree = []
          }
      })
    },

    handleClickDep(row,type) {
      console.log(row)
      if(type === '预览'){

          if(row.url){
            if(this.getFileName(row.name) === ".pdf"){
                this.urls = row.url
                this.showInfo = true
            }else if (this.getFileName(row.name) === ".docx" || this.getFileName(row.name) === ".doc"){
                this.docxContent = row.url
                this.showInfos = true
            }else{
                if(this.getFileName(row.name) === ".jpg" || this.getFileName(row.name) === ".png"){
                    this.showImgDingurlsss = row.url
                    this.showImgDing = true
                }
                else{
                    this.$message({type: 'warning', message: '请检查是否为有效的简历类型~' })
                }
            }
          }

      }


      if(type === '下载'){
          const replacedString = row.url.replace('+', '%2B')
          var link = document.createElement('a')
          link.href = replacedString
          link.download = row.name
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
      }


      if(type === '删除'){
          this.$confirm('此操作将删除资料， 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
              this.handleDelete(data.id)
          }).catch(() => {
              this.$message({ type: 'info', message: '已取消删除' })
          })
      }

      this.fromsID = row
      // this.from.input1 = row.realName
      this.from.input2 = row.weChatName ? row.weChatName : ''
      this.from.input3 = row.weChatNumber ? row.weChatNumber : ''
      this.from.input4 = row.phoneNumber ? row.phoneNumber : ''

      this.imagesList = [row.profilePhotos]

      if(type === '编辑'){
        this.disable = false
        this.dialogDrawer = true
      }

      if(type === '详情'){
        this.disable = true
        this.dialogDrawer = true
      }

    },

    handleCloseDrawerCler(){
      this.dialogDrawer = false
    },

    handleSizeChange(size){
      this.pageSize = size
      this.getApiList()
    },

    handleCurrentChange(size){
      this.pageNum = size
      this.getApiList()
    },

  }
}

</script>


<style lang="less" scoped>

    .boxshadow{
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      transition: .3s;
      padding: 10px 10px 0px 10px;
    }

    .btn{
        background-color: #1890ff;
        border-color: #1890ff;
    }

    /deep/ .el-card__body{
          padding: 0px;
    }

  

    /deep/ .el-input__prefix{
        margin-top: -5px;
    }


    /deep/ .el-tree-node.is-current > .el-tree-node__content{
        color: #1890ff;
        background: #e8f4ff;
    }

    .add:hover{
        padding: 10px 10px;
        background: #4992df;
        color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-drawer__header{
        font-weight: 900;
        font-size: 18px;
        background: #f5f7fa;
        padding: 15px 20px;
    }

    /deep/.el-divider--horizontal{
        margin-top: -26px;
    }

    /deep/ .el-dialog__header{
        text-align: start;
    }

    /deep/ .el-drawer__header{
        text-align: start;
    }

    /deep/ .el-input__suffix-inner{
        display: flex;
        margin-top: -3px;
    }

    /deep/ .el-range__close-icon{
        position: absolute;
        right: 0px;
    }
    /deep/ .el-range-separator{
        margin-top: -10px;
    }

    /deep/ .el-icon-date{
        display: none;
    }
    .no_click {
        pointer-events: none;
    }




</style>
























// WEBPACK FOOTER //
// src/customerManagement/customerManagement.vue